import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoctorComponent } from '../doctor/doctor.component';
import { DoctormainComponent } from './doctormain/doctormain.component';
import { DoctorRouting } from '../doctor/doctor.route';
import { AppointmentComponent } from './appointment/appointment.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DocappComponent } from './docapp/docapp.component';

import { PopupformComponent } from './popupform/popupform.component';
import {MatDialogModule, MatRadioModule, MatSnackBarModule, MatCardModule, MatTabsModule, MatIconModule, MatInputModule, MatDatepickerModule, MatFormFieldModule} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AppointmentdetailComponent } from './appointmentdetail/appointmentdetail.component';
import { AddscheduleComponent } from './addschedule/addschedule.component';
import { DoctorchatComponent } from './doctorchat/doctorchat.component';
import { ManagepatientComponent } from './managepatient/managepatient.component';
import { NgxLoadingModule, } from 'ngx-loading';

import {NgxPaginationModule} from 'ngx-pagination';
import { ProfilemanageComponent } from './profilemanage/profilemanage.component';
import { ServiceeditComponent } from './serviceedit/serviceedit.component';
import { ServiceaddComponent } from './serviceadd/serviceadd.component';
import { SharedModule } from '../common/shared.module';
import { Ng2UploaderModule } from 'ng2-uploader';
import { PatientprofileComponent } from './patientprofile/patientprofile.component';
import { DocumentviewerComponent } from './documentviewer/documentviewer.component';
import { TagalertComponent } from './tagalert/tagalert.component';
import { SendnotificationComponent } from './sendnotification/sendnotification.component';
import { AppointmentscreenComponent } from './appointmentscreen/appointmentscreen.component';
import { FilterModule } from '../filter/filter.module';
@NgModule({
  imports: [
    CommonModule,
    DoctorRouting,
    NgbModule.forRoot(),
    MatDialogModule,
    FormsModule ,
    FlexLayoutModule,
    ReactiveFormsModule,
    NgxLoadingModule,
    NgxPaginationModule,
    Ng2UploaderModule,
    SharedModule,
    FilterModule,
    MatSnackBarModule,MatDialogModule,MatCardModule,MatTabsModule,MatIconModule,
    MatInputModule,MatDatepickerModule,MatFormFieldModule, MatRadioModule
  ],
  declarations: [
    DoctorComponent,
    DoctormainComponent,
     AppointmentComponent,
     DocappComponent,
       PopupformComponent,
       AppointmentdetailComponent,
       AddscheduleComponent,
       DoctorchatComponent,
       ManagepatientComponent,
       ProfilemanageComponent,
       ServiceeditComponent,
       ServiceaddComponent,
       PatientprofileComponent,
       DocumentviewerComponent,
       TagalertComponent,
       SendnotificationComponent,
       AppointmentscreenComponent,
      ],
  entryComponents: [
    PopupformComponent,
    ServiceeditComponent,
    ServiceaddComponent,
    DocumentviewerComponent,
    TagalertComponent,
    SendnotificationComponent,
 ],
})
export class DoctorModule { }
